import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";

export const getMyEmployerPayrollTaxSavingsChartData = <TDatum,>(
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerPayrollTaxSavingsChartData"],
    queryFn: (): Promise<TDatum[]> => {
      return fetchWithAuth<TDatum[]>(
        "getMyEmployerPayrollTaxSavingsChartData"
      );
    },
    enabled: isQueryEnabled(options),
    staleTime: SHORT_STALE_TIME,
  });
};
